type BootstrapOptions = {
  name?: string;
};

type BootstrapMount = (root: HTMLElement) => void;

export function bootstrapModule(
  selector: string,
  mount: BootstrapMount,
  options: BootstrapOptions = {},
): void {
  // eslint-disable-next-line no-restricted-globals, no-restricted-properties
  const root = document.querySelector<HTMLElement>(selector);
  if (!root) {
    if ((import.meta as unknown as { env?: { DEV?: boolean } }).env?.DEV) {
      // Keep local dev visibility without crashing production runtime.
      console.warn(`[clients/bootstrap] root not found for ${options.name ?? selector}`);
    }
    return;
  }

  mount(root);
}
